(function() {
  'use strict';

  let isLoading = false;
  let noMoreProducts = false;
  let nextPageUrl = null;

  function getNextPageUrl() {
    // Dawn uses pagination__item links with page= in href, not rel="next"
    const links = document.querySelectorAll('a.pagination__item[href*="page="]');
    let maxPage = 0;
    let currentPage = 1;

    // Get current page from URL
    const urlParams = new URLSearchParams(window.location.search);
    currentPage = parseInt(urlParams.get('page') || '1');

    // Find the link with page= value higher than current
    let nextLink = null;
    links.forEach(a => {
      const pageMatch = a.href.match(/page=(\d+)/);
      if (pageMatch) {
        const pageNum = parseInt(pageMatch[1]);
        if (pageNum === currentPage + 1) nextLink = a;
      }
    });

    return nextLink ? nextLink.href : null;
  }

  function getNextUrlFromDoc(doc) {
    const links = doc.querySelectorAll('a.pagination__item[href*="page="]');
    let maxPage = 0;
    let nextLink = null;
    links.forEach(a => {
      const pageMatch = a.href.match(/page=(\d+)/);
      if (pageMatch) {
        const pageNum = parseInt(pageMatch[1]);
        if (pageNum > maxPage) {
          maxPage = pageNum;
          nextLink = a;
        }
      }
    });
    // Only return if it's genuinely a "next" page
    const currentMatch = nextPageUrl ? nextPageUrl.match(/page=(\d+)/) : null;
    const currentNum = currentMatch ? parseInt(currentMatch[1]) : 1;
    return (maxPage > currentNum) ? nextLink.href : null;
  }

  function createSpinner() {
    const spinner = document.createElement('div');
    spinner.id = 'infinite-scroll-spinner';
    spinner.style.cssText = 'display:none;text-align:center;padding:20px;width:100%;';
    spinner.innerHTML = `
      <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="16" fill="none" stroke="#999" stroke-width="3"
          stroke-dasharray="80" stroke-dashoffset="60">
          <animateTransform attributeName="transform" type="rotate"
            from="0 20 20" to="360 20 20" dur="0.8s" repeatCount="indefinite"/>
        </circle>
      </svg>`;
    return spinner;
  }

  function hidePagination() {
    document.querySelectorAll('nav.pagination, .pagination').forEach(el => {
      el.style.display = 'none';
    });
  }

  function loadMoreProducts() {
    if (isLoading || noMoreProducts || !nextPageUrl) return;
    isLoading = true;

    const spinner = document.getElementById('infinite-scroll-spinner');
    if (spinner) spinner.style.display = 'block';

    const fetchUrl = nextPageUrl;

    fetch(fetchUrl)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid > li.grid__item');
        const grid = document.querySelector('#product-grid');

        if (newItems.length > 0 && grid) {
          newItems.forEach(item => grid.appendChild(item.cloneNode(true)));
        }

        // Find next page from fetched doc
        const fetchedLinks = doc.querySelectorAll('a.pagination__item[href*="page="]');
        const currentMatch = fetchUrl.match(/page=(\d+)/);
        const currentNum = currentMatch ? parseInt(currentMatch[1]) : 1;

        let foundNext = null;
        fetchedLinks.forEach(a => {
          const m = a.href.match(/page=(\d+)/);
          if (m && parseInt(m[1]) === currentNum + 1) foundNext = a.href;
        });

        nextPageUrl = foundNext;
        if (!nextPageUrl) noMoreProducts = true;

        isLoading = false;
        if (spinner) spinner.style.display = 'none';
      })
      .catch(() => {
        isLoading = false;
        const spinner = document.getElementById('infinite-scroll-spinner');
        if (spinner) spinner.style.display = 'none';
      });
  }

  function onScroll() {
    const scrolledTo = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    if (scrolledTo >= pageHeight - 400) loadMoreProducts();
  }

  function init() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    nextPageUrl = getNextPageUrl();
    if (!nextPageUrl) return;

    hidePagination();

    const spinner = createSpinner();
    grid.parentNode.insertBefore(spinner, grid.nextSibling);

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
